import React from "react"
import styled from "styled-components"

import Layout from "../components/layout"
import InternalLinkingBlock from "../components/internalLinkingBlock"

import Text from "@airasia/phoenix-components/components/Text"

import { GTM_EVENT_CATEGORY } from "../utils/constants"

import CarouselCard from "../components/carousel"
import LocationCarousel from "../components/locationCarousel"
import ExpandableContentBlock from "../components/expandableContentBlock"

// const CarouselCard = loadable(() => import("../components/carousel"))
const ContentWrapper = styled.div`
  margin: 5% 16px;

  @media only screen and (min-width: 720px) {
    margin: 2% 8px;
  }
`

const TextWrapper = styled.div`
  border-style: solid;
  padding: 0px 8px 8px 8px;
  border-width: thin;
  border-color: gray;
  box-shadow: rgb(0 0 0 / 20%) 0px 1px 3px 1px;
  border-radius: 8px;
  background-color: rgb(255, 255, 255);
  border: 1px solid rgb(213, 217, 226);
`

const IndexPage = props => {
  const { metaTags, content, pageHeading, layout } = props.pageContext
  const { path } = props

  const {
    location_carousel,
    content_block_1,
    hotel_deals,
    content_block_2,
    internal_link_block_headings,
  } = content

  const { pageComponentTranslation } = layout

  const locationCarousels = location_carousel.map(carousel => {
    return (
      <LocationCarousel data={carousel} gtmConsumerName={carousel.purpose} />
    )
  })

  const internalLinkBlocks = internal_link_block_headings.map(block => {
    return (
      <ContentWrapper>
        <InternalLinkingBlock
          blockTitle={block.headline}
          linkObjects={block.internal_links}
          gtmConsumerName={GTM_EVENT_CATEGORY.COUNTRY_LOCATION}
        />
      </ContentWrapper>
    )
  })

  const hotelCarousels = hotel_deals.map(hotelBlock => {
    return (
      <CarouselCard
        data={hotelBlock.hotels}
        headline={hotelBlock.headline}
        subheadline={hotelBlock.subheadline}
        location={hotelBlock.location}
        gtmConsumerName={
          GTM_EVENT_CATEGORY.HOMEPAGE + " - " + hotelBlock.location
        }
        translations={pageComponentTranslation.carousel}
      />
    )
  })

  const contentBlock1 = content_block_1 ? (
    <ContentWrapper>
      <ExpandableContentBlock
        contentBlock={content_block_1}
        translations={pageComponentTranslation.contentBlock}
      />
    </ContentWrapper>
  ) : null

  const contentBlock2 = content_block_2 ? (
    <ContentWrapper>
      <ExpandableContentBlock
        contentBlock={content_block_2}
        translations={pageComponentTranslation.contentBlock}
      />
    </ContentWrapper>
  ) : null

  return (
    <Layout pageData={{ metaTags, pageHeading, layout }}>
      {locationCarousels}
      {contentBlock1}
      {hotelCarousels}
      {contentBlock2}
      {internalLinkBlocks}
    </Layout>
  )
}

export default IndexPage
